import { TableHeadersType } from "../tableHeadersType";

export const THINKS_TO_DO_HEADERS: TableHeadersType[] = [
  {
    label: "INTERVIEW DATE & TIME",
    value: "interview_date_time",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "CANDIDATE NAME",
    value: "candidate_name",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "APPLIED FOR",
    value: "applied_for",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "APPLICATION DATE",
    value: "application_date",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "JOB LOCATION",
    value: "job_location",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "RECRUITER",
    value: "recruiter",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "PROGRESS",
    value: "progress",
  },
  {
    label: "Action",
    value: "action",
    checked: true,
    defaultChecked: true,
  },
];


export const PENDING_APPROVAL_HEADERS: TableHeadersType[] = [
 
  {
    label: "CANDIDATE NAME",
    value: "candidate_name",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "APPLIED FOR",
    value: "applied_for",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "APPLICATION DATE",
    value: "application_date",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "JOB LOCATION",
    value: "job_location",
    defaultChecked: true,
    checked: true,
  },
   {
    label: "PROGRESS",
    value: "progress",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "RECRUITER",
    value: "recruiter",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "APPROVAL RECEIVED ON",
    value: "approval_date",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "STATUS",
    value: "status",
    defaultChecked: true,
    checked: true,
  },
 
  {
    label: "Action",
    value: "action",
    checked: true,
    defaultChecked: true,
  },
];

